module.exports = __webpack_public_path__ + "static/media/cent.d5ecc28a.jpg";